var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabular-header',{staticClass:"q-py-lg",attrs:{"columns":_vm.tabularColumns},scopedSlots:_vm._u([{key:"cell-title-value",fn:function(ref){
var value = ref.value;
return [_c('text-ellipsis',{staticClass:"text-tes-white",attrs:{"text":value}})]}},{key:"cell-status-value",fn:function(ref){
var ref_value = ref.value;
var status = ref_value.status;
var statuses = ref_value.statuses;
return [_c('admin-coupon-status',{attrs:{"coupon-status":status,"coupon-status-in-persian":statuses}})]}},{key:"cell-createdAt-value",fn:function(ref){
var value = ref.value;
return [_c('date-tooltipped',{staticClass:"text-tes-white",attrs:{"iso-date":value}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }